<template>
  <v-card
      class="rounded-lg white--text"
      color="secondary"
      height="350"
  >
    <v-card-title class="mr-3 mt-1">
      <span style="font-size: medium; font-weight: bold" class="primary--text">
        موجودی بانک :
      </span>
      <span class="white--text mr-3">
        {{ bankRemain | toMoney(0) }}
      </span>
      <span style="font-size: medium; font-weight: bold" class="primary--text mr-3">
        ریال
      </span>
    </v-card-title>
    <v-divider class="lightSecondary ml-3 mr-3 mb-1"></v-divider>
    <v-card-text>
      <v-row>
        <v-col cols="8" class="white--text">
          <p class=" mt-2 mr-5" v-if="posRemain != 0">
            <span style="font-size: small; font-weight: bold" class="primary--text">موجودی کارتخوان</span>
            <span class="mr-2">{{ posRemain | toMoney(0) }}</span>
            <span style="font-size: small; font-weight: bold" class="primary--text mr-2">ريال</span>
          </p>
          <p class=" mr-5" v-if="panelRemain != 0">
            <span style="font-size: small; font-weight: bold" class="primary--text">موجودی درگاه</span>
            <span class="mr-2">{{ panelRemain | toMoney(0) }}</span>
            <span style="font-size: small; font-weight: bold" class="primary--text mr-2">ريال</span>
          </p>
          <p class=" mr-5" v-if="boxRemain != 0">
            <span style="font-size: small; font-weight: bold" class="primary--text">موجودی صندوق</span>
            <span class="mr-2">{{ boxRemain | toMoney(0) }}</span>
            <span style="font-size: small; font-weight: bold" class="primary--text mr-2">ريال</span>
          </p>
          <p class=" mr-5 mb-8" v-if="imprestRemain != 0">
            <span style="font-size: small; font-weight: bold" class="primary--text">موجودی تنخواه</span>
            <span class="mr-2">{{ imprestRemain | toMoney(0) }}</span>
            <span style="font-size: small; font-weight: bold" class="primary--text mr-2">ريال</span>
          </p>
          <template v-if="sum != 0">
            <v-divider class="lightSecondary mt-4 ml-5"></v-divider>
            <p class=" mr-5 mt-3 card-bottom">
              <span style="font-size: medium; font-weight: bold" class="success--text">مجموع : </span>
              <span class="mr-2 font-weight-bold">{{ sum | toMoney(0) }}</span>
              <span style="font-size: medium; font-weight: bold" class="success--text mr-2">ريال</span>
            </p>
          </template>
        </v-col>
        <v-col cols="3" class="mt-8">
          <v-img class="mt-3" max-height="120" src="/img/icons/cash-bank.svg"></v-img>

        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {toString} from "lodash";

export default {
  name: "CashAndBank",
  components: {},
  props: {
    id: {},
  },
  data() {
    return {
      bankRemain: 955000032,
      posRemain: 188000,
      panelRemain: 2148000,
      boxRemain: 942000,
      imprestRemain: 332000,
      accounts: null,
    };
  },
  computed: {
    sum() {
      return this.bankRemain + this.posRemain + this.panelRemain + this.boxRemain + this.imprestRemain
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.request({
        url: this.endpoint('accounts/cashAndBankReport'),
        method: "get",
        success: data => {
          this.bankRemain = data.bank
          this.posRemain = data.pos
          this.boxRemain = data.box
          this.imprestRemain = data.imprest
          this.panelRemain = data.panel
        },
      })
    },
  }

}
</script>

<style scoped lang="scss">

.card-bottom {
  position: absolute;
  bottom: 1px;
}
</style>

